import styled from 'styled-components'

export const Wrapper = styled.div<{ icon?: boolean; hide?: boolean }>`
  display: flex;
  gap: 8px;
  justify-content: center;
  background: rgba(97, 105, 113, 0.08);
  border: 0.5px solid rgba(97, 105, 113, 0.2);
  border-radius: 12px;
  padding: ${({ icon }) => (icon ? '8px' : '6px 9px')};
  visibility: ${({ hide }) => (hide ? 'hidden' : 'visible')};
`
export const Button = styled.button<{ active?: boolean; icon?: boolean }>`
  display: flex;
  padding: 0;
  align-items: center;
  border: none;
  font-size: 14px;
  letter-spacing: 0.1px;
  background-color: transparent;
  color: ${({ active }) => (active ? '#DCB97E' : '#7B8187')};
  cursor: ${({ active }) => (active ? 'default' : 'pointer')};
`
